import { useEffect } from 'react';
import { installScrollTapGuard } from '../../utils/ui/scrollTapGuard';

/**
 * Mounts the global scroll-tap guard once at the app root. Swallows a tap that
 * lands inside a list/container the user JUST touch-scrolled, so a fling no
 * longer activates whatever is under the finger (native iOS list behavior).
 * Touch-only — desktop/mouse is never affected. See `scrollTapGuard.js`.
 */
export default function useScrollTapGuard() {
  useEffect(() => installScrollTapGuard(), []);
}
